export const ConnectorNodeType = {
  Marriage: 'marriage',
  Divorce: 'divorce',
  Invisible: 'invisible',
} as const;

export type ConnectorNodeType =
  (typeof ConnectorNodeType)[keyof typeof ConnectorNodeType];

export const PersonRootType = {
  Root: 'root',
  SecondaryRoot: 'secondaryRoot',
  Child: 'child',
} as const;

export type PersonRootType =
  (typeof PersonRootType)[keyof typeof PersonRootType];

export type Id = string;

export type Tree = {
  [key: Id]: TreeNodeType;
};

export type TreeNodeId = string;

export const TreeNodeKind = {
  Person: 'person',
  Marriage: 'marriage',
  Divorce: 'divorce',
  Family: 'family',
  Invisible: 'invisible',
} as const;

export type TreeNodeKind = (typeof TreeNodeKind)[keyof typeof TreeNodeKind];

export type TreeNodeType = {
  id: TreeNodeId;
  name: string;
  kind?: TreeNodeKind;
  type?: 'input';
  isRoot?: boolean;
  isSpouse?: boolean;
  isExSpouse?: boolean;
  isPrimaryLineage?: boolean;
  children?: TreeNodeId[];
  parents?: TreeNodeId[];
  exSpouses?: TreeNodeId[]; // used as "right-side partners" on root
  spouses?: TreeNodeId[]; // used as "left-side current spouse(s)" on root
};

type LeafValues<T> = T extends object
  ? { [K in keyof T]: LeafValues<T[K]> }[keyof T]
  : T;

export const EdgeHandles = {
  vertical: { source: 'h-children', target: 'h-parents' },
  horizontalLeft: { source: 'h-spouse-left', target: 'h-spouse-right' },
  horizontalRight: { source: 'h-ex-right', target: 'h-ex-left' },
} as const;

export type EdgeHandles = LeafValues<typeof EdgeHandles>;
